import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { MemberAccessPage } from '../features/team/team-pages';

export const Route = createFileRoute('/manage/$companySlug/settings/members_/$userId/access')({
  validateSearch: z
    .object({ externalIdentityLink: z.enum(['confirm', 'failed']).optional() })
    .catch({}),
  component: MemberAccessRoute,
});

function MemberAccessRoute() {
  const { companySlug, userId } = Route.useParams();
  const { externalIdentityLink } = Route.useSearch();
  return (
    <MemberAccessPage
      companySlug={companySlug}
      membershipId={userId}
      {...(externalIdentityLink ? { externalIdentityLink } : {})}
    />
  );
}
